import FeedbackOfferSku from './FeedbackOfferSku';
import defaultOfferImage from './img/xyo-tokens-320x180.jpg';
const FeedbackOffers = {
    [FeedbackOfferSku.FacebookAd]: {
        image: defaultOfferImage,
        reward: {
            coin: 2000,
        },
        sku: FeedbackOfferSku.FacebookAd,
        title: 'Facebook Feedback',
    },
    [FeedbackOfferSku.GooglePlaystore]: {
        image: defaultOfferImage,
        reward: {
            coin: 500,
        },
        sku: FeedbackOfferSku.GooglePlaystore,
        title: 'Google Playstore Feedback',
    },
    [FeedbackOfferSku.AppleAppstore]: {
        image: defaultOfferImage,
        reward: {
            coin: 500,
        },
        sku: FeedbackOfferSku.AppleAppstore,
        title: 'Apple Appstore Feedback',
    },
    [FeedbackOfferSku.General]: {
        image: defaultOfferImage,
        reward: {
            coin: 500,
        },
        sku: FeedbackOfferSku.General,
        title: 'General Feedback',
    },
    [FeedbackOfferSku.SentinelXNFCReview]: {
        image: defaultOfferImage,
        reward: {
            coin: 500,
        },
        sku: FeedbackOfferSku.SentinelXNFCReview,
        title: 'SentinelX NFC Review',
    },
    [FeedbackOfferSku.SentinelXBLEReview]: {
        image: defaultOfferImage,
        reward: {
            coin: 500,
        },
        sku: FeedbackOfferSku.SentinelXBLEReview,
        title: 'SentinelX BLE Review',
    },
};
export default FeedbackOffers;
